import React, { useState } from 'react'
import CustomAlert from '../../../../components/shared/CustomAlert'
import { observer } from 'mobx-react-lite'
import { MDBCollapse } from 'mdb-react-ui-kit'
import { UIInputCheckbox } from './../../../../components/forms/form-fields'
import LGCStore from './../../store/LeaderGoalCard.store'
import './LeaderGoalsForecast.scss'

const LeaderGoalsForecast = ({ viewMode, ownerName }) => {
  const { getGoalYear, getGrowthGoal } = LGCStore,
    growthGoal = getGrowthGoal(),
    goalYear = getGoalYear()

  const [isChecked, setIsChecked] = useState(false)

  return (
    <div id='LeaderGoalsForecastComponent'>
      <MDBCollapse open={viewMode === 'goals' && LGCStore.canEnableAutoForecast()}>
        <CustomAlert color='warning'>
          This year hasn&apos;t completed yet. We can average our your sales to help settings next year&apos;s goal.
          <div style={{ padding: '4px' }}>
            <UIInputCheckbox
              label={<strong>Auto-forecast remainder of year?</strong>}
              name={`should_autoforecast`}
              id={`should_autoforecast`}
              onChange={evt => {
                setIsChecked(!isChecked)
                if (!isChecked) LGCStore.enableAutoForecast()
                else LGCStore.disableAutoForecast()
              }}
              checked={isChecked}
            />
          </div>
        </CustomAlert>
      </MDBCollapse>
    </div>
  )
}

export default observer(LeaderGoalsForecast)
